<template>
  <page-section
    :section-name="name"
    :content="textContent"
    class="bg-white"
    v-slot="{ content }"
  >
    <h3 class="mb-6">{{ content.title }}</h3>
    <div class="w-full text-right pb-6">
      <a
        v-if="locale === 'fr'"
        :href="`${publicPath}2019_Audited_Financial_Statements-French.pdf`"
        class="text-blue border-blue border-b-2 hover:border-b-4 hover:bg-blue-pale focus:border-b-4 focus:bg-blue-pale"
        >{{ content.download }}</a
      >
      <a
        v-else
        :href="`${publicPath}2019_Audited_Financial_Statements-English.pdf`"
        class="text-blue border-blue border-b-2 hover:border-b-4 hover:bg-blue-pale focus:border-b-4 focus:bg-blue-pale"
        >{{ content.download }}</a
      >
    </div>
    <h4>{{ content.commitment.title }}</h4>
    <p>{{ content.commitment.body }}</p>
  </page-section>
</template>

<script>
export default {
  name: "InterParesExpensesIn2019",
  components: {
    pageSection: () => import("@/components/PageSection.vue"),
  },
  data() {
    return {
      name: "interParesExpensesIn2019",
      images: [
        require("../assets/images/water_colour_circle.png"),
        require("../assets/images/water_colour_circle.png"),
        require("../assets/images/water_colour_circle.png"),
        require("../assets/images/water_colour_circle.png"),
      ],
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    textContent() {
      const { name } = this;

      return this.$t(`i18nSections.${name}`);
    },
  },
};
</script>
